import { chakra } from '@chakra-ui/react'
import { SerieItem } from './SerieItem'

export const ChakraSerieItem = chakra(SerieItem);